'use strict';

module.exports = function (schema) {
  schema.path('isDeleted', { type: Boolean, default: false });
};